const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  
  if (!refreshToken) {
    throw new Error('No refresh token');
  }

  const response = await fetch(`${API_URL}/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken })
  });

  if (!response.ok) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('Session expired');
  }

  const data = await response.json();
  localStorage.setItem('accessToken', data.accessToken);
  localStorage.setItem('refreshToken', data.refreshToken);
  if (data.user) {
    localStorage.setItem('user', JSON.stringify(data.user));
  }
  
  return data.accessToken;
}

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('accessToken');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  };

  let res = await fetch(`${API_URL}${endpoint}`, config);

  if ((res.status === 401 || res.status === 403) && localStorage.getItem('refreshToken')) {
    try {
      const newToken = await refreshAccessToken();
      config.headers.Authorization = `Bearer ${newToken}`;
      res = await fetch(`${API_URL}${endpoint}`, config);
    } catch (error) {
      throw error;
    }
  }

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || 'Błąd serwera');
  }

  return data;
};

export default API_URL;